import React from "react";
import { Link } from "react-router-dom";
import ResponsiveContainer from "./ResponsiveContainer";
import ResponsiveGrid from "./ResponsiveGrid";

export default function PublicFooter() {
  return (
    <footer className="bg-gray-50 border-t border-border-light mt-auto">
      <ResponsiveContainer size="lg" className="py-8 sm:py-10 lg:py-12">
        {/* Preamble Section */}
        <div className="text-center mb-8 sm:mb-10 pb-6 sm:pb-8 border-b border-border-light">
          <p className="text-body sm:text-body-lg text-text-secondary max-w-3xl mx-auto mb-3">
            Track Adderall, Vyvanse, Concerta, and other ADHD medications across
            campus pharmacies. Get notified the moment your prescription is
            available instead of calling multiple locations daily.
          </p>
          <p className="text-supporting text-text-secondary">
            By using our service, you agree to our{" "}
            <Link
              to="/privacy"
              className="text-trust-blue hover:text-trust-blue/80 underline transition-colors duration-200"
            >
              Privacy Policy
            </Link>
            .
          </p>
        </div>

        {/* Main Columns - Responsive grid */}
        <ResponsiveGrid
          columns={{ mobile: 1, tablet: 2, desktop: 4 }}
          gap="lg"
          align="start"
        >
          {/* Column 1: Logo and Company Name */}
          <div className="text-center sm:text-left">
            <div className="flex items-center justify-center sm:justify-start gap-3 mb-4">
              <img src="/logo.png" alt="CampusMeds logo" className="h-8 w-auto object-contain" />
              <h3 className="text-section-header text-gray-900 font-inter font-semibold">

              </h3>
            </div>
          </div>

          {/* Column 2: Contact Info */}
          <div className="text-center sm:text-left">
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4 font-inter">
              Contact
            </h3>
            <div className="text-supporting text-gray-700 space-y-2">
              <p>4505 Kenny Rd #1022</p>
              <p>Columbus, OH 43220</p>
              <p className="mt-3">
                <span className="font-medium text-gray-900">Phone:</span>{" "}
                <a
                  href="tel:+16505323736"
                  className="hover:text-trust-blue transition-colors duration-200"
                >
                  (650) 532-3736
                </a>
              </p>
              <p>
                <span className="font-medium text-gray-900">Email:</span>{" "}
                <a
                  href="mailto:team@inpstockrx.com"
                  className="hover:text-trust-blue transition-colors duration-200 break-all"
                >
                  team@inpstockrx.com
                </a>
              </p>
            </div>
          </div>

          {/* Column 3: Legal Links */}
          <div className="text-center sm:text-left">
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4 font-inter">
              Legal
            </h3>
            <div className="space-y-3">
              <Link
                to="/privacy"
                className="block text-supporting text-text-secondary hover:text-trust-blue transition-colors duration-200"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="block text-supporting text-text-secondary hover:text-trust-blue transition-colors duration-200"
              >
                Terms of Service
              </Link>
            </div>
          </div>

          {/* Column 4: Company Links */}
          <div className="text-center sm:text-left">
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4 font-inter">
              Company
            </h3>
            <div className="space-y-3">
              <Link
                to="/about"
                className="block text-supporting text-text-secondary hover:text-trust-blue transition-colors duration-200"
              >
                About Us
              </Link>
              <Link
                to="/contact"
                className="block text-supporting text-text-secondary hover:text-trust-blue transition-colors duration-200"
              >
                Contact
              </Link>
              <Link
                to="/check-status"
                className="block text-supporting text-text-secondary hover:text-trust-blue transition-colors duration-200"
              >
                Check Status
              </Link>
            </div>
          </div>
        </ResponsiveGrid>

        {/* Copyright */}
        <div className="mt-8 sm:mt-10 pt-6 sm:pt-8 border-t border-border-light text-center">
          <p className="text-supporting text-text-secondary">
            © {new Date().getFullYear()} inPstockRx, LLC. All rights reserved.
          </p>
          <p className="text-caption text-text-secondary mt-2">
            CampusMeds is a medication adherence tracking service. This is not
            medical advice.
          </p>
        </div>
      </ResponsiveContainer>
    </footer>
  );
}
